
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[airport]",
      function () {
        return require("private-next-pages/[airport]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[airport]"])
      });
    }
  